define.alias("shared/components/shared/ui/report/industry-comparison", "settings/components/shared/ui/report/industry-comparison");